import {
  Breadcrumbs,
  BreadcrumbsProps,
} from "design-system/components/primitives/breadcrumbs/breadcrumbs";
import "./archive-page-body.scss";

import { ReactNode, useEffect, useState } from "react";
import { LazyComponent } from "design-system/components/system/lazy-component/lazy-component";
import { ArchivePageTopper } from "../archive-page";
import { SimpleTheme } from "design-system/utils/theme";

export interface ArchivePageBodyProps {
  breadcrumbs?: BreadcrumbsProps;
  topper?: ArchivePageTopper;
  topContent?: ReactNode;
  preFooterContent?: ReactNode;
  theme?: SimpleTheme;
  content: ReactNode;
}

export function ArchivePageBody({
  breadcrumbs,
  topper,
  topContent,
  preFooterContent,
  content,
  theme,
}: ArchivePageBodyProps) {
  const [bodyContent, setBodyContent] = useState<ReactNode>("");
  useEffect(() => {
    setBodyContent(
      <main id="skipto-main" tabIndex={-1}>
        {topper && <LazyComponent {...topper} />}
        {breadcrumbs && (
          <Breadcrumbs {...breadcrumbs} theme={breadcrumbs.theme || theme} />
        )}
        <div className="hbs-archive-page-body__extra-content">
          <div className="hbs-archive-page-body__extra-content-main">
            <div className="hbs-page-body hbs-archive-page-body__extra-content-inner">
              {topContent}
            </div>
          </div>
        </div>
        <div data-theme={theme}>
          <div className="hbs-archive-page-body__content">
            <div className="hbs-archive-page-body__content-inner">
              {content}
            </div>
          </div>
        </div>
        <div className="hbs-archive-page-body__extra-content">
          <div className="hbs-archive-page-body__extra-content-main">
            <div className="hbs-page-body hbs-archive-page-body__extra-content-inner">
              {preFooterContent}
            </div>
          </div>
        </div>
      </main>,
    );
  }, [topper, breadcrumbs, topContent, theme, content, preFooterContent]);
  return bodyContent;
}
